// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M5.82 1.5V4.74M10.15 1.5V4.74M7.98 12.1V14.5M5.82 4.74L10.15 4.74L12.42 4.74C12.74 4.74 13 4.96 13 5.24L13 6.34C13 6.61 12.87 6.88 12.63 7.07L11.81 7.73L11.79 8.93C11.72 10.7 10.04 12.1 7.99 12.1C5.93 12.1 4.25 10.7 4.18 8.93L4.16 7.71L3.36 7.07C3.13 6.88 3 6.61 3 6.34L3 5.24C3 4.96 3.26 4.74 3.58 4.74L5.82 4.74Z',
];
